import { render, staticRenderFns } from "./PurgeRoomDialog.vue?vue&type=template&id=70a3b111&"
import script from "./PurgeRoomDialog.vue?vue&type=script&lang=js&"
export * from "./PurgeRoomDialog.vue?vue&type=script&lang=js&"
import style0 from "./PurgeRoomDialog.vue?vue&type=style&index=0&id=70a3b111&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDialog,VImg,VRow})
